import { render } from "./AddFaqTagModal.vue?vue&type=template&id=c560d98e&ts=true"
import script from "./AddFaqTagModal.vue?vue&type=script&lang=ts"
export * from "./AddFaqTagModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__